// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Aisx","row":"ProcedureTreatmentSummary_row__3tkBQ"};